module.exports = __webpack_public_path__ + "img/not-found.d3ed3160.png";